import hooks from "./hooks";

export default {
  hooks,
};
